import { knowledgeQuestions } from './questions';
import { LevelProps } from '../dto/levelsDTO';

import financeFreshman from '~/assets/images/financeFreshman.png';
import risingStar from '~/assets/images/risingStar.png';
import wallStreetWizard from '~/assets/images/wallStreetWizard.png';

const levels: LevelProps[] = [ {
  name: 'A Finance Freshman',
  icon: financeFreshman,
  description: 'Just starting out? Join other "Finance Freshmen" on Birdwingo and turn those 😰 into 😎 with our step-by-step investing courses!',
  minCorrectAnswers: 0,
  maxCorrectAnswers: 2,
  financialSkillsNow: 'Low',
  progressNow: 0.2,
  financialSkills3months: 'Above average',
  progress3months: 0.8,
  rank: 47,
}, {
  name: 'A Rising Star',
  icon: risingStar,
  description: "You've got the basics down, but there's more to explore. Level up your skills with Birdwingo's interactive tools and challenges.",
  minCorrectAnswers: 3,
  maxCorrectAnswers: 4,
  financialSkillsNow: 'Medium',
  progressNow: 0.5,
  financialSkills3months: 'Above average',
  progress3months: 0.8,
  rank: 56,
}, {
  name: 'A Wall Street Wizard',
  icon: wallStreetWizard,
  description: 'Wow, a "Wall Street Wizard" in the making! Ready to tackle advanced strategies? Birdwingo has the tools to help you conjure up some financial magic.',
  minCorrectAnswers: 5,
  maxCorrectAnswers: knowledgeQuestions.length,
  financialSkillsNow: 'Above average',
  progressNow: 0.8,
  financialSkills3months: 'Finance star',
  progress3months: 0.92,
  rank: 68,
} ];

export default levels;
